import { Controller } from "@hotwired/stimulus";

// Controller for info dialogs that stack on top of existing dialogs
// Used when clicking info icons ("i" buttons) inside forms or other dialogs
export default class extends Controller {
  static targets = ["modal"];

  connect() {
    this._closeHandler = this.enableBodyScroll.bind(this);
    this._handleBackdropClick = this.handleBackdropClick.bind(this);
    this._turboFrameLoadHandler = this.handleTurboFrameLoad.bind(this);
    
    this.modalTarget.addEventListener("close", this._closeHandler);
    this.modalTarget.addEventListener("click", this._handleBackdropClick)
    this.modalTarget.addEventListener("turbo:frame-load", this._turboFrameLoadHandler);
  }

  disconnect() {
    this.modalTarget.removeEventListener("close", this._closeHandler);
    this.modalTarget.removeEventListener("click", this._handleBackdropClick);
    this.modalTarget.removeEventListener("turbo:frame-load", this._turboFrameLoadHandler);
  }

  handleTurboFrameLoad() {
    // Safari iOS 26 fix: Set both html and body background
    document.documentElement.style.backgroundColor = '#ffffff';
    document.body.style.backgroundColor = '#ffffff';
    this.modalTarget.showModal();
    this.disableBodyScroll();
  }

  show() {
    // Safari iOS 26 fix: Set both html and body background
    document.documentElement.style.backgroundColor = '#ffffff';
    document.body.style.backgroundColor = '#ffffff';
    this.modalTarget.showModal();
    this.disableBodyScroll();
  }

  close() {
    this.modalTarget.close();
  }

  handleBackdropClick(event) {
    if (this.modalTarget.dataset.closeOnBackdrop !== "true"){
      return;
    } 
    if (event.target !== this.modalTarget) return;

    this.close();
  }

  disableBodyScroll() {
    document.body.style.overflow = "hidden";
  }

  enableBodyScroll() {
    // Only enable scroll if NO dialogs are still open
    // This prevents scroll unlock when closing info dialog while parent dialog is still open
    const openDialogs = document.querySelectorAll("dialog[open]");
    if (openDialogs.length === 0) {
      document.body.style.removeProperty("overflow");
      // Safari iOS 26 fix
      document.documentElement.style.removeProperty("background-color");
      document.body.style.removeProperty("background-color");
    }
  }
}
